import { css } from 'styled-components';

// Import variables
import { INVOICE_TYPES } from 'helpers/variables';

// Import types
import { DefaultFieldType } from 'types/views/form';

// Import styles
import { size } from 'components/styles';

type Field = DefaultFieldType & { invoiceType: string[] };

const { BUSINESS, INDIVIDUAL } = INVOICE_TYPES;

export const FORM_FIELDS: Field[] = [
	{
		label: 'payment:company',
		name: 'client.type',
		type: 'radio',
		value: BUSINESS,
		gridConfig: {
			0: 6,
			[size.semi]: 4
		},
		invoiceType: [BUSINESS, INDIVIDUAL],
		required: true,
		customStyles: css`
			min-height: 7rem;
		`
	},
	{
		label: 'payment:individual',
		name: 'client.type',
		type: 'radio',
		value: INDIVIDUAL,
		gridConfig: {
			0: 10,
			[size.semi]: 12
		},
		invoiceType: [BUSINESS, INDIVIDUAL],
		required: true,
		customStyles: css`
			min-height: 7rem;
		`
	},
	{
		label: 'payment:company_name',
		name: 'client.company_name',
		type: 'text',
		invoiceType: [BUSINESS],
		required: true
	},
	{
		label: 'payment:vat_number',
		name: 'client.vat_number',
		type: 'text',
		invoiceType: [BUSINESS],
		required: true
	},
	{
		label: 'payment:firstname',
		name: 'client.firstname',
		type: 'text',
		invoiceType: [INDIVIDUAL],
		required: true
	},
	{
		label: 'payment:lastname',
		name: 'client.lastname',
		type: 'text',
		invoiceType: [INDIVIDUAL],
		required: true
	},
	{
		label: 'payment:street',
		name: 'client.street',
		type: 'text',
		invoiceType: [BUSINESS, INDIVIDUAL],
		required: true
	},
	{
		label: 'payment:building',
		name: 'client.building',
		type: 'text',
		gridConfig: {
			0: 16,
			[size.xsmall]: 8
		},
		invoiceType: [BUSINESS, INDIVIDUAL],
		required: true
	},
	{
		label: 'payment:apartment',
		name: 'client.apartment',
		type: 'text',
		gridConfig: {
			0: 16,
			[size.xsmall]: 8
		},
		invoiceType: [BUSINESS, INDIVIDUAL],
		required: false
	},
	{
		label: 'payment:zip',
		name: 'client.zip',
		type: 'text',
		gridConfig: {
			0: 16,
			[size.xsmall]: 8
		},
		invoiceType: [BUSINESS, INDIVIDUAL],
		required: true
	},
	{
		label: 'payment:city',
		name: 'client.city',
		type: 'text',
		gridConfig: {
			0: 16,
			[size.xsmall]: 8
		},
		invoiceType: [BUSINESS, INDIVIDUAL],
		required: true
	}
];
